export default {
  header_issues: "Issues",
  header_work_orders: "Work Orders",
  header_performed_work: "Performed Work",
  header_items: "Items",
  header_events: "Events",
  header_comments: "Comments",
  header_layouts_with_zone: "Layouts with Zone",

  label_sort_by: "Sort by",
  label_sort_order: "Sort order",
  label_when_clicked: "When clicked",

  config_sort_by_priority: "Priority",
  config_sort_by_raised: "Raised",
  config_sort_by_deadline: "Deadline",
  config_sort_by_issue_work_order: "Issue / Work Order Priority",
  config_sort_by_designation: "Designation",
  config_sort_by_designation_layout: "Layout Designation",
  config_sort_by_designation_area: "Area Designation",
  config_sort_by_item_id: "Item ID",
  config_sort_by_performed_date: "Performed date-time",
  config_sort_by_issue_raised: "Issue Raised",
  config_sort_by_issue_priority: "Issue Priority",

  config_descending: "Descending",
  config_ascending: "Ascending",

  config_open_overview: "Open Overview",
  config_open_corrective_work: "Ad-hoc Corrective Work",
  config_open_add_to_work_order: "Add to Work-Order",
  config_open_perform_work: "Perform Work",
  config_open_display_on_layout: "Display on Layout",
  config_open_display_zone_on_layout: "Display Zone on Layout",
  config_open_item_list_for_area: "Open Item list sorted for Area",
  config_open_area_overview: "Open Area Overview (if applicable)",

  label_include_item_no_area: "Include Items with no Area",
  label_include_item_no_location: "Include Items with no Location",

  label_click_not_performed_items: "Clicking on non-performed Items",
  label_click_not_performed_issues: "Clicking on non-performed Issues",
  label_click_performed_items: "Clicking on performed Items",
  label_click_performed_issues: "Clicking on performed Issues",
  label_hide_performed: "Hide performed",

  config_statistic_mean: "Mean",
  config_statistic_median: "Median",
  config_statistic_mode: "Mode",

  config_yes: "Yes",
  config_no: "No",
  config_true: "True",
  config_false: "False",

  config_click_open_item: "Open Item Overview",
  config_click_open_issue: "Open Issue Overview",
  config_click_open_perform_work: "Open Perform Work",
  config_click_perform_work: "Perform Work",
}
